var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticStyle:{"margin":"50px 0"}},[_c('span',{staticStyle:{"font-size":"32px"}},[_vm._v(_vm._s(_vm.$t('shippingAddress')))])]),_c('v-row',[_c('AddressSection')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }